//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React                      from 'react';
import _                          from 'lodash';
import { connect }                from 'react-redux';
import { bindActionCreators }     from 'redux';
import { compose }                from 'redux';
import ComponentHelper            from '@/helper/ComponentHelper';
import PropTypes                  from '@/components/PropTypes';
import StatelessMembershipOptions from '@/components/stateless/composed/MembershipOptions';

export class Component extends React.Component {
    render() {
        const { history, options, userMembershipOption, companyMembershipOption, isLoggedIn } = this.props;

        return (
            <StatelessMembershipOptions
                options={options}
                history={history}
                userMembershipOption={userMembershipOption}
                companyMembershipOption={companyMembershipOption}
                isLoggedIn={isLoggedIn}
            />
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }
}

export const MembershipOptions = Component;

Component.propTypes = {
    history:                 PropTypes.object,
    isLoggedIn:              PropTypes.bool,
    options:                 PropTypes.array,
    userMembershipOption:    PropTypes.object,
    companyMembershipOption: PropTypes.object,
};

Component.defaultProps = {
    history:                 null,
    isLoggedIn:              false,
    options:                 [],
    userMembershipOption:    null,
    companyMembershipOption: null,
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

const mapDispatchToProps = (dispatch) => bindActionCreators(
    // No actions needed for this component currently
    {},
    dispatch,
);

const mapStateToProps = (state) => {
    const membershipOptions       = _.get(state, 'membership.options', []);
    const isLoggedIn              = !_.isEmpty(_.get(state, 'user.token', null));
    const companyMembershipOption = _.get(state, 'user.userCompany.membershipOption', null);
    const userMembershipOption    = _.get(state, 'user.membershipOption', null);
    const orderedOptions          = _.orderBy(membershipOptions, ['priority'], ['asc']);

    return {
        options: orderedOptions,
        isLoggedIn,
        companyMembershipOption,
        userMembershipOption,
    };
};

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps,
))(Component);
